import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    box: {
        width: "100%",
        [theme.breakpoints.down("desktop")]: {
            width: "92%",
        },
        "& .MuiSlider-track": { height: "20px" },
        "& .MuiSlider-rail": { height: "20px", background: "#888" },
        "& .MuiSlider-thumb": {
            height: "24px",
            width: "24px",
            background: "#fff",
        },

        "& .MuiSlider-markLabel": {
            marginTop: "14px",
            whiteSpace: "break-spaces",
            textAlign: "center",
            fontSize: "14px",
            letterSpacing: 0,
            lineHeight: "18px",
            color: "#888",
            width: "90px",
        },
        "& .MuiSlider-markLabelActive": {
            marginTop: "14px",
            whiteSpace: "break-spaces",
            textAlign: "center",
            fontWeight: "bold",
            color: "#353535",
            width: "90px",
        },
        "& .MuiSlider-valueLabelOpen": {
            display: "none",
        },
        "& .MuiSlider-mark": {
            display: "none",
        },
    },
}));

export default useStyles;
